export const API_URL = "https://cremation.fernwood.com/api/";
// export const API_URL ="http://localhost/fernwoodcremation_live/fernwoodcremationwebservice/api/";
//export const API_URL = "http://192.168.11.205/cremation_system/webservice/api/";
